// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExpressSetupAccountDto
 */
export interface IExpressSetupAccountDto {
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupAccountDto
     */
    name?: string;
    /**
     * Should be encrypted with RSAES_OAEP_SHA_1 algorithm and encoded in base64 format
     * @type {string}
     * @memberof IExpressSetupAccountDto
     */
    encrypted_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupAccountDto
     */
    routing_transit_number: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupAccountDto
     */
    account_category?: IExpressSetupAccountDtoAccountCategoryEnum;
}

/**
* @export
* @enum {string}
*/
export enum IExpressSetupAccountDtoAccountCategoryEnum {
    CHECKING = 'CHECKING',
    SAVING = 'SAVING',
    NONE = 'NONE'
}


/**
 * Check if a given object implements the IExpressSetupAccountDto interface.
 */
export function instanceOfIExpressSetupAccountDto(value: object): value is IExpressSetupAccountDto {
    if (!('routing_transit_number' in value) || value['routing_transit_number'] === undefined) return false;
    return true;
}

export function IExpressSetupAccountDtoFromJSON(json: any): IExpressSetupAccountDto {
    return IExpressSetupAccountDtoFromJSONTyped(json, false);
}

export function IExpressSetupAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'encrypted_number': json['encrypted_number'] == null ? undefined : json['encrypted_number'],
        'routing_transit_number': json['routing_transit_number'],
        'account_category': json['account_category'] == null ? undefined : json['account_category'],
    };
}

export function IExpressSetupAccountDtoToJSON(json: any): IExpressSetupAccountDto {
    return IExpressSetupAccountDtoToJSONTyped(json, false);
}

export function IExpressSetupAccountDtoToJSONTyped(value?: IExpressSetupAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'encrypted_number': value['encrypted_number'],
        'routing_transit_number': value['routing_transit_number'],
        'account_category': value['account_category'],
    };
}

